import { MovePreferences, LocationResult } from '../types/weather';
import { LocationSuggestion } from './locationSearchApi';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://weather-backend-879484113802.us-central1.run.app/api';

export interface MovePlanningApiResponse {
  success: boolean;
  data: LocationResult[];
  preferences: MovePreferences;
  timestamp: string;
}

export interface SingleLocationApiResponse {
  success: boolean;
  data: LocationResult;
  preferences: MovePreferences;
  timestamp: string;
}

class MovePlanningApiService {
  async compareLocations(preferences: MovePreferences, locations: LocationSuggestion[]): Promise<MovePlanningApiResponse> {
    console.log('API_BASE_URL:', API_BASE_URL);
    console.log('Making request to:', `${API_BASE_URL}/move-planning/compare-locations`);
    console.log('Request body:', { preferences, locations });
    
    const response = await fetch(`${API_BASE_URL}/move-planning/compare-locations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ preferences, locations }),
    });

    console.log('Response status:', response.status);
    console.log('Response ok:', response.ok);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.log('Error response data:', errorData);
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Response data:', data);
    return data;
  }

  async analyzeLocation(preferences: MovePreferences, location: string): Promise<SingleLocationApiResponse> {
    const response = await fetch(`${API_BASE_URL}/move-planning/analyze-location`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ preferences, location }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return response.json();
  }
}

export const movePlanningApi = new MovePlanningApiService();
